import { Navigate } from "react-router-dom";

const RequireAuth = ({ children }) => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (!user || !user.accessToken) {
        return <Navigate to="/predict" replace />;
    }

    return children;
};

export default RequireAuth;
